import {
    createFeatureSelector,
    createReducer,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { Culture } from './culture';

export const cultureFeatureKey = 'culture';

export interface CultureState {
    culture: Culture;
    configOverrides: ConfigOverrides;
}

export interface ConfigOverrides {
    mapboxEnvironment: Environment;
    servicesEnvironment: Environment;
}

export const initialState: CultureState = {
    configOverrides: {
        mapboxEnvironment: 'dev',
        servicesEnvironment: 'dev',
    },
    culture: new Culture(),
};

export const cultureReducer = createReducer(initialState);

export const getCultureFeatureState =
    createFeatureSelector<CultureState>(cultureFeatureKey);

export const getCulture = createSelector(
    getCultureFeatureState,
    (state) => state.culture
);

export const getServicesEnvironmentOverride = createSelector(
    getCultureFeatureState,
    (state) => state.configOverrides.servicesEnvironment
);

export const cultureStoreModule = StoreModule.forFeature(
    cultureFeatureKey,
    cultureReducer
);
